import Repository from './Repository'
import TokenService from '../helpers/token'

const resource = Repository.defaults.baseURL;
const resourceActiveCode = Repository.defaults.activeCodeURL;

export default {
    async create(request) {
        const response = await Repository.post(`${resource}/agency`, request, {
            headers: TokenService.getHeader()
        })
        return response
    },
    async list(params) {
        const response = await Repository.get(`${resource}/agency`, {
            params,
            headers: TokenService.getHeader()
        })
        return response
    },
    async detail(id) {
        const response = await Repository.get(`${resource}/agency/${id}`, {
            headers: TokenService.getHeader()
        })
        return response
    },
    async deleteOneItem(id) {
        const response = await Repository.delete(`${resource}/agency/${id}`, {
            headers: TokenService.getHeader()
        })
        return response
    },
    async deleteManyItems (ids) {
        const response = await Repository.delete(`${resource}/agency/`, {
            headers: TokenService.getHeader()
        })
        return response
    },
    async update(id, body) {
        const response = await Repository.patch(`${resource}/agency/${id}`, body, {
            headers: TokenService.getHeader()
        })
        return response
    },
    async getListUserByPermission(params) {
        const response = await Repository.get(`${resource}/user/list-user/by-permission`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },
    async getOrderList(params) {
        const response = await Repository.get(`${resource}/agency/list-order`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },
    async getOrderDetail(id) {
        const response = await Repository.get(`${resource}/agency/order/${id}`, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async getContact(params) {
        const response = await Repository.get(`${resource}/agency/list-contact`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },
    async listStatus(params) {
        const response = await Repository.get(`${resource}/agency/status`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },
    async createNewOrder(request) {
        const response = await Repository.post(`${resource}/agency/create-order`, request, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async exportExcelOrders(params) {
        const response = await Repository.get(`${resource}/agency/order/export`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },
    async exportActiveCodeForOrder(id) {
        const response = await Repository.get(`${resource}/agency/order/${id}/export`, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async updateOrder(orderId, data) {
        const response = await Repository.patch(`${resource}/agency/update-order/${orderId}`, data, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async exportContactForOrder(params) {
        const response = await Repository.get(`${resource}/agency/export/list-contact`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },

    // Mã kích hoạt
    async listActiveCode(params) {
        const response = await Repository.get(`${resourceActiveCode}/active-code`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },
    async exportExcelActiveCode(params) {
        const response = await Repository.get(`${resourceActiveCode}/active-code/export`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },
    async getDetailActive(id, params) {
        const response = await Repository.get(`${resourceActiveCode}/active-code/${id}`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },
    async getActiveCodeRelated(id, body) {
        const response = await Repository.post(`${resourceActiveCode}/active-code/related/${id}`, body, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async getEmployeeReport(params) {
        const response = await Repository.get(`${resource}/report/agency/employee`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    }
}